exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-2f19e194]{border:solid #fff;border-width:0 10px 10px 0;display:inline-block;padding:10px}.back-btn[data-v-2f19e194]{background-color:#e7e7e7;padding:5px 20px;box-shadow:-1px 1px 3px rgba(0,0,0,.1);display:inline-block}.back-btn[data-v-2f19e194]:hover{background-color:#f5f5fa;text-decoration:none;opacity:1;transition:.5s ease}.i-styles[data-v-2f19e194],a[data-v-2f19e194]{color:#727272}.thumbnail[data-v-2f19e194]{padding:10px}.pixi-wrapper[data-v-2f19e194]{margin-top:-60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f19e194","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/apps/participate/participate-app.vue
// module id = 596
// module chunks = 1